// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"793":"39d1e2f4","825":"c2a368a6"}[chunkId] + ".css";
};